
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import { Transporte } from '@/__env/lib/Expedicion/Transportes';
    import etiquetas_envio from './lista-buscador-seleccion-etiquetas-envio.vue';
    import facturar_todo from './lista-buscador-seleccion-facturacion.vue';
    import notaventa from './lista-buscador-seleccion-nota-de-venta.vue';
    import mercadopago from './lista-buscador-seleccion-nota-mercadopago.vue';
    import presupuesto from './lista-buscador-seleccion-presupuestos.vue';
    import facturas from './lista-buscador-seleccion-facturas.vue';
    import hojapiso from './lista-buscador-seleccion-hoja-de-piso.vue';
    import listado from './lista-buscador-seleccion-listado.vue';
    import etiquetas_items from './lista-buscador-seleccion-etiquetas-items.vue';
    import editar_transporte from './lista-buscador-seleccion-editar-transportes.vue';

    import * as Pedidos from '@/__env/lib/Ventas/Pedidos';
    import { Envio } from '@/__env/lib/Ventas/Envios';
    import _ from 'lodash';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
import { Utiles } from '@/__env/pluggins/event-bus';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            etiquetas_envio,
            listado,
            facturar_todo,
            mercadopago,
            notaventa,
            presupuesto,
            hojapiso,
            etiquetas_items,
            editar_transporte,
            facturas,
        }
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Seleccionados() { return this.Controlador.Seleccionados; }
        @Watch( 'Seleccionados' )
        onSeleccionados()
        {
            if ( this.Seleccionados.hasRows() )
            {
                this.SubModo = '';
                this.Abierto = true;
            }
            else
                this.Abierto = false;
        }
        public Abierto: boolean = false;

        public SubModo: string = '';

        public get SeleccionadosPorTipo()
        {
            let e: { Tipo: any; Pedidos: Pedido[]; }[] = [];
            let items = _.groupBy( this.Seleccionados, x => x.Tipo.Id );
            for ( let a of Object.keys( items ) )
            {
                e.push( { Tipo: Pedidos.Tipos.toTipo( a ), Pedidos: items[a] } );
            }
            return e;
        }

        public get Estado() { return this.Controlador.Buscador.Estado; }

        Cerrar()
        {
            this.Seleccionados.clear();
        }
    }
